import { useTranslation } from "react-i18next";
import { Manager } from "../../../Manager";
import { fetchRepsForManager, type Rep } from "../../../../state/reps";
import { useState, useCallback } from "react";
import { Box, Button, Callout, Spinner } from "@radix-ui/themes";
import { DownloadIcon, ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { downloadRepAssignments } from "../../../../lib/download-rep-assignments";

function DownloadRepsAssignmentsButton() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setLoading(true);
    setError(null);
    try {
      await downloadRepAssignments();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="solid"
        size="2"
        disabled={loading}
        onClick={handleDownload}
      >
        {loading ? <Spinner size="1" /> : <DownloadIcon />}
        {t("reps.downloadAssignments")}
      </Button>
      {error && (
        <Callout.Root color="red" size="1" mt="2">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>{error}</Callout.Text>
        </Callout.Root>
      )}
    </>
  );
}

export function ManageReps() {
  const { t } = useTranslation();
  const fetchData = useCallback(() => fetchRepsForManager(), []);

  return (
    <Box p="4">
      <Manager.Root<Rep>
        title={t("reps.title")}
        fetchData={fetchData}
        actionButtons={<DownloadRepsAssignmentsButton />}
      >
        <Manager.Table>
          <Manager.Column<Rep>
            header={t("reps.repName")}
            accessor={(r) => r.full_name}
          />
          <Manager.Column<Rep>
            header={t("reps.totalTerritories")}
            accessor={(r) => r.territories_count}
          />
          <Manager.Column<Rep>
            header={t("reps.totalStores")}
            accessor={(r) => r.stores_count}
          />
          <Manager.Column<Rep>
            header={t("reps.agencies")}
            accessor={(r) => r.agency_names || "—"}
          />
        </Manager.Table>
      </Manager.Root>
    </Box>
  );
}
